<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('warehouse_items')"
          :directory="[$t('warehouse_items'), $t('warehouse_item')]"
          :icon="'users'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
         
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-warehouse-item-modal
      v-if="isWarehouseModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeModal"
    />
  
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="warehouse-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
 
   
   
  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { collection, urlGenerator, formatDateToLocal, numberWithCurrencyMuseum } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner, WarehouseTypeList } from "@app/Mixins/Global/FilterMixins";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Warehouse",
  extends: CoreLibrary,
  mixins: [owner, WarehouseTypeList, DeleteMixin],
  data() {
    return {
      urlGenerator,
      numberWithCurrencyMuseum,
      formatDateToLocal,
      isWarehouseModalActive: false,
      isContactModalActive: false,
      tableId: "warehouse-item-modal",
      contacttableId: "contact-modal",
      confirmationModalActive: false,
      isQuickViewModalActive: false,
      organizationModal: false,
      warehouseActivitiesModal: false,
      editedUrl: "",
      viewAllDeal: false,
      viewAllFollower: false,
      isNoteModal: false,
      noteRowData: null,
      warehouseId: null,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      warehouseFundData: {},
      
      options: {
        name: this.$t("warehouse_table"),
        url: "crm/warehouse-items",
        showHeader: true,
        countView: true,
        columns: [
        
        {
          title: this.$t("type"),
          type: "custom-html",
		  key: "type_id",
          modifier: (value, row) => {
            let type = (value == 1) ? this.$t('warehouse_1') : ((value == 2) ? this.$t('warehouse_2') : this.$t('warehouse_3')) ;
			  return type;
          },
        },
        {
          title: this.$t("warehouse_qty"),
          type: "custom-html",
		  key: "qty",
          modifier: (value, row) => {
            return value;
          },
        },
        {
          title: this.$t("price_sum"),
          type: "custom-html",
		  key: "price",
          modifier: (value, row) => {
			  return this.numberWithCurrencyMuseum(value);
          },
        },
		 {
          title: this.$t("warehouse_id"),
          type: "custom-html",
          key: "warehouse",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${
                  value.name
                }</span>`
              : "-";
          },
        },
		 {
          title: this.$t("warehouse_descriptions"),
          type: "custom-html",
          key: "descriptions",
          modifier: (value, row) => {
            return value
              ? `<span class="">${
                  value
                }</span>`
              : "-";
          },
        },
        {
          title: this.$t("created_at"),
          type: "custom-html",
          key: "created_at",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${formatDateToLocal(row.created_at)}</span>`
              : "-";
          },
        },
        
	    
      
        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
        filters: [
       
        {
            title: this.$t("lead_group"),
            type: "radio",
            key: "type_id",
            option: [
            {
            id: 1,
            name: this.$t('warehouse_1')
        },
        {
            id: 2,
            name: this.$t('warehouse_2')
        },
        {
            id: 3,
            name: this.$t('warehouse_3')
        },
            ],
            listValueField: "name",
          },
         
			
		
         
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 50,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          /*{
            title: this.$t("quick_view"),
            icon: "zap",
            type: "modal",
            component: "app-warehouse-quick-view",
            modalId: "quickViewModal",
            url: "",
          },*/
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-warehouse-modal",
            modalId: "warehouse-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "warehouse-delete-modal",
            url: "",
          },
     
        ],
      },
    };
  },
  methods: {
	  
	
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `crm/warehouse-items/${rowData.id}`;
        this.isWarehouseModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/warehouse-items/${rowData.id}`;
        this.confirmationModalActive = true;
      } else if (actionObj.title == this.$t("delete_fund")) {
        this.deleteFund(rowData.id);
      }
    },
    openModal() {
      this.isWarehouseModalActive = true;
    },


    closeModal() {
      this.isWarehouseModalActive = false;
      this.selectedUrl = "";
      $("#warehouse-modal").modal("hide");
    },

  
    deleteFund(id){

      
      this.warehouseFundData.id = id;
      this.warehouseFundData.change = 1;
      this.warehouseFundData.fund_id = null;
      

      this.axiosPatch({
        url: '/crm/warehouse-items/' + id,
        data: this.warehouseFundData,
      }).then((response) => {
        this.$toastr.s(response.data.message);
            this.errors = {}
            this.$emit('update-request');
            this.$hub.$emit('reload-' + this.tableId);

      }).catch(({ response }) => {

      }).finally(() => {


      });


    },

 
   

  },
  computed: {

  },
  mounted() {
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
